/**
 * PLAT-FIRM-LOGO-1c — the one email rule for every screen (owner 10-24: email
 * validation is Utils). Same rule as the server, core/utils/email.py: exactly
 * one address — one @, a dot, and an ending that is a real top-level domain
 * from the IANA list (emailTlds.ts, generated from core/utils/iana_tlds.txt).
 * The server re-checks on save; this only lets the screen say so as you type.
 */
import { REAL_TLDS } from './emailTlds'

const MAX = 254
const ADDRESS = /^[a-z0-9._%+'-]+@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z0-9-]{2,})$/

/** The address trimmed and lower-cased, or null unless it is exactly one valid address. */
export function cleanEmail(value: string | null | undefined): string | null {
  const address = (value ?? '').trim().toLowerCase()
  if (!address || address.length > MAX) return null
  const match = ADDRESS.exec(address)
  return match && REAL_TLDS.has(match[2]) ? address : null
}

export function isValidEmail(value: string | null | undefined): boolean {
  return cleanEmail(value) !== null
}
